export const apiDatePattern = 'MM/dd/yyyy';
export const monthDayPattern = 'MMM dd';
export const monthDayYearPatternDashSeparator = 'MM-DD-YYYY';
export const yearMonthDayPatternDashSeparator = 'yyyy-MM-dd';
export const monthYearPattern = 'MMM yyyy';
export const monthDayYearPattern = 'MMM dd, yy';
export const monthDayFullYearPattern = 'MMM dd, yyyy';
export const yearMonthDayNoSeparator = 'yyMMdd';
export const timePattern = 'p';
export const hoursMinutesTimePattern = 'h:mm';
export const hoursMinutesFullTimePattern = 'H:mm';
export const onlyYearPattern = 'yyyy';
export const dateTimeISOPattern = `yyyy-MM-dd'T'HH:mm:ss`;
export const apiDateTimeUtcPattern = "MM/dd/yyyy HH:mm:ss 'UTC'";
export const apiDateTimePattern = 'MM/dd/yyyy HH:mm:ss';
export const fullTimePattern = 'hh:mm:ss a';
export const fullTime24hPattern = 'HH:mm:ss';
export const hoursMinutesAmPmPattern = 'hh:mm a';
export const monthDayFullYearHoursMinutesAmPmPattern = 'MMM dd, yyyy hh:mm a';
